import { render, staticRenderFns } from "./IndividualA.vue?vue&type=template&id=1fd57308&scoped=true"
import script from "./IndividualA.vue?vue&type=script&lang=js"
export * from "./IndividualA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd57308",
  null
  
)

export default component.exports